import QrcodeImage from 'assets/images/qrcode.svg'
import LOCALES from 'constants/locales'
import { TFunction } from 'src/providers/TranslateProvider/TranslateProvider'
import { BadgeType } from 'src/types'
import { DEFAULT_LOCALE, GATSBY_MAIN_URL } from '@constants'
import { freshchatService } from '@margex/ui'

const getHeaderDropdownAppData = (t: TFunction, locale: string, isBlog?: boolean) => {
  const previewBlockData = {
    title: t('Margex App'),
    image: QrcodeImage,
    previewDescription: t('Scan to Download App IOS & Android'),
    buttonLabel: t('Learn more'),
  }

  const locales = LOCALES.map(item => item.code)
  const blogLocalesWithoutPath = ['en', 'ru', 'fa', 'ko']

  const l = locale === 'en' ? '' : `${locale}/`

  const data = {
    chapter1: {
      title: t('Margex Platform'),
      data: [
        {
          title: t('About Us'),
          text: t('Find out more about our company'),
          href: isBlog ? `/page/${l}about-us` : '/about-us',
        },
        {
          title: t('Help Center'),
          text: t('We have collected the answers to all your questions'),
          href:
            locale === DEFAULT_LOCALE ? `${GATSBY_MAIN_URL}/help-center` : `${GATSBY_MAIN_URL}/${locale}/help-center`,
          badgeType: BadgeType.Popular,
          includeLangsArr: locales,
        },
        {
          title: t('Contact Us'),
          text: t("Have any questions? Let's get in touch."),
          href: isBlog ? `/page/${l}contact-us` : '/contact-us',
        },
        {
          title: t('Fees'),
          text: t('Get to know our trading and funding fees'),
          href:
            locale === DEFAULT_LOCALE ? `${GATSBY_MAIN_URL}/margex-fees` : `${GATSBY_MAIN_URL}/${locale}/margex-fees`,
          includeLangsArr: locales,
        },
        {
          title: t('Security'),
          text: t('Learn more about how Margex protects its users'),
          href: isBlog ? `/page/${l}platforms-security` : '/platforms-security',
        },
        {
          title: t('Live chat'),
          text: t("Margex's 24/7 live chat support is always at your service"),
          showChat(id?: boolean) {
            if (!id || typeof window === 'undefined') {
              return
            }
            freshchatService.open()
          },
        },
      ],
    },
    chapter2: {
      title: t('Blog and News'),
      data: [
        {
          title: t('For beginners'),
          text: t('New to crypto? We have prepared some articles for you.'),
          href: blogLocalesWithoutPath.includes(locale)
            ? 'https://margex.com/blog/for-beginners'
            : `https://margex.com/${locale}/blog/for-beginners`,
          badgeType: BadgeType.Hot,
          includeLangsArr: locales,
        },
        {
          title: t('Popular'),
          text: t('Get the most popular cryptocurrency topics on our blog'),
          href: blogLocalesWithoutPath.includes(locale)
            ? 'https://margex.com/blog/popular'
            : `https://margex.com/${locale}/blog/popular`,
          includeLangsArr: locales,
        },
        {
          title: t('Trading articles'),
          text: t('Read our blog for the latest trading strategy articles, ideas and tutorials.'),
          href: blogLocalesWithoutPath.includes(locale)
            ? 'https://margex.com/blog/trading-strategies'
            : `https://margex.com/${locale}/blog/trading`,
          includeLangsArr: locales,
        },
      ],
    },
  }

  return { data, previewBlockData }
}

export default getHeaderDropdownAppData
